import { ReactElement } from "react";
import JoinAsosWorldButton from "../../components/JoinAsosWorldButton/JoinAsosWorldButton";
import EarlyAccessButton from "../../components/earlyAccessButton/EarlyAccessButton";
import { useProduct } from "../../context/product/ProductContext";
import { useVariant } from "../../context/variant/VariantContext";
import { useNewInBoxConditions } from "../../hooks/useNewInBoxConditions";
import { getCustomerLoyaltyAccess } from "../../utils/loyalty/getCustomerLoyaltyAccess";
import { Variant } from "../../types/productTypes/product";

interface ButtonRendererProps {
  renderAddToBag: () => ReactElement;
  isInStock?: boolean;
}

export default function ButtonRenderer({
  renderAddToBag,
  isInStock,
}: ButtonRendererProps) {
  const { product } = useProduct();
  const { selectedVariant } = useVariant() as {
    selectedVariant: Variant | null;
  };
  const showLoyaltyNewInButton = useNewInBoxConditions();

  const resolvedIsInStock =
    selectedVariant?.isInStock ||
    (!selectedVariant && (product?.isInStock ?? isInStock));
  if (!resolvedIsInStock) {
    return null;
  }

  const { customerAccess } = getCustomerLoyaltyAccess(product);
  if (customerAccess) {
    return (
      <EarlyAccessButton
        renderAddToBag={renderAddToBag}
        customerAccess={customerAccess}
      />
    );
  }

  if (showLoyaltyNewInButton) {
    return <JoinAsosWorldButton />;
  }

  return renderAddToBag();
}
